module.exports = __webpack_public_path__ + "static/media/dheya5.d87e07de.png";